import { Fragment, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { saveAddPrinter } from "actions/printerActions";
import Loading from "components/Loading";
import {
    Modal,
    ModalBody,
    ModalFooter
} from "reactstrap";

function Modaladdprinter(props) {
    var { isLoading } = props.printer;
    var { isOpenModalAddPrinter, openModal, saveAddPrinter, printer_selected } = props;
    const [printer, setPrinter] = useState(printer_selected || "");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [access_token, setAccessToken] = useState("");
    const [auto_place, setAutoPlace] = useState("");
    const [api_key, setApiKey] = useState("");
    const [api_signature, setApiSignature] = useState("");
    const [api_secret, setApiSecret] = useState("");
    const [api_store_id, setApiStoreId] = useState("");
    const [api_store_id_spoke_custom_products, setApiStoreIdSpokeCustomProducts] = useState("");
    const [api_store_id_swiftpod, setApiStoreIdSwiftPOD] = useState("");
    const [api_store_id_monster_digital, setApiStoreIdMonsterDigital] = useState("");
    const [api_store_id_printed_mint, setApiStoreIdPrintedMint] = useState("");
    const [api_store_id_lumient, setApiStoreIdLumient] = useState("");
    const [api_store_id_swagrabbit, setApiStoreIdSwagRabbit] = useState("");
    const [api_store_id_candle_builders, setApiStoreIdCandleBuilders] = useState("");
    const [api_store_id_prima_printing, setApiStoreIdPrimaPrinting] = useState("");
    const [api_store_id_district_photo, setApiStoreIdDistrictPhotos] = useState("");
    const [api_store_id_todays_graphics, setApiStoreIdTodaysGraphics] = useState("");
    const [api_store_id_harrier, setApiStoreIdHarrier] = useState("");
    const [api_store_id_print_pigeons, setApiStoreIdPrintPigeons] = useState("");
    const [api_store_id_colorway, setApiStoreIdColorway] = useState("");
    const [api_store_id_printed_simply, setApiStoreIdPrintedSimply] = useState("");
    const [api_store_id_imagine_your_photos, setApiStoreIdImagineYourPhotos] = useState("");
    const [api_store_id_pic_the_gift, setApiStoreIdPicTheGift] = useState("");
    const [api_store_id_woyc, setApiStoreIdWoyc] = useState("");
    const [api_store_id_smart_printee, setApiStoreIdSmartPrintee] = useState("");
    const [api_store_id_shirt_monkey, setApiStoreIdShirtMonkey] = useState("");
    const [api_store_id_t_shirt_and_sons, setApiStoreIdTShirtAndSons] = useState("");
    const [api_store_id_print_clever, setApiStoreIdPrintClever] = useState("");
    const [api_store_id_printify_choice, setApiStoreIdPrintifyChoice] = useState("");
    const [api_store_id_printful_com, setApiStoreIdPrintfulCom] = useState("");
    const [api_store_id_opt_ondemand, setApiStoreIdOptOndemand] = useState("");
    const [api_store_id_atelier_katanga, setApiStoreIdAtelierKatanga] = useState("");
    const [webhook_secret_key, setWebhookSecretKey] = useState("");
    const [base_url, setBaseUrl] = useState("");
    const [client_id, setClientId] = useState("");
    const [client_secret, setClientSecret] = useState("");
    const [data, setData] = useState({});
    const [app_key, setAppKey] = useState("");
    const [app_secret, setAppSecret] = useState("");
	const { t } = useTranslation();

    const onClickSaveAddPrinter = () => {
        saveAddPrinter({ printer, username, password, access_token, auto_place, api_key, api_signature, api_secret, api_store_id, api_store_id_spoke_custom_products, api_store_id_swiftpod, api_store_id_monster_digital, api_store_id_printed_mint, api_store_id_lumient, api_store_id_swagrabbit, api_store_id_candle_builders, api_store_id_prima_printing, api_store_id_district_photo, api_store_id_todays_graphics, api_store_id_harrier, api_store_id_print_pigeons, api_store_id_colorway, api_store_id_printed_simply, api_store_id_imagine_your_photos, api_store_id_pic_the_gift, api_store_id_woyc, api_store_id_smart_printee, api_store_id_shirt_monkey, api_store_id_t_shirt_and_sons, api_store_id_print_clever, api_store_id_printify_choice, api_store_id_printful_com, api_store_id_opt_ondemand, api_store_id_atelier_katanga, webhook_secret_key, base_url, client_id, client_secret, data, app_key, app_secret }, openModal);
    };

    const onChange = (e) => {
        if (e.target.name === "printer") {
            setPrinter(e.target.value);
        }
        if (e.target.name === "username") {
            setUsername(e.target.value);
        }
        if (e.target.name === "password") {
            setPassword(e.target.value);
        }
        if (e.target.name === "access_token") {
            setAccessToken(e.target.value);
        }
        if (e.target.name === "auto_place") {
            setAutoPlace(e.target.value);
        }
        if (e.target.name === "api_key") {
            setApiKey(e.target.value);
        }
        if (e.target.name === "api_signature") {
            setApiSignature(e.target.value);
        }
        if (e.target.name === "api_secret") {
            setApiSecret(e.target.value);
        }
        if (e.target.name === "api_store_id") {
            setApiStoreId(e.target.value);
        }
        if (e.target.name === "api_store_id_spoke_custom_products") {
            setApiStoreIdSpokeCustomProducts(e.target.value);
        }
        if (e.target.name === "api_store_id_swiftpod") {
            setApiStoreIdSwiftPOD(e.target.value);
        }
        if (e.target.name === "api_store_id_monster_digital") {
            setApiStoreIdMonsterDigital(e.target.value);
        }
        if (e.target.name === "api_store_id_printed_mint") {
            setApiStoreIdPrintedMint(e.target.value);
        }
        if (e.target.name === "api_store_id_lumient") {
            setApiStoreIdLumient(e.target.value);
        }
        if (e.target.name === "api_store_id_swagrabbit") {
            setApiStoreIdSwagRabbit(e.target.value);
        }
        if (e.target.name === "api_store_id_candle_builders") {
            setApiStoreIdCandleBuilders(e.target.value);
        }
        if (e.target.name === "api_store_id_prima_printing") {
            setApiStoreIdPrimaPrinting(e.target.value);
        }
        if (e.target.name === "api_store_id_district_photo") {
            setApiStoreIdDistrictPhotos(e.target.value);
        }
        if (e.target.name === "api_store_id_todays_graphics") {
            setApiStoreIdTodaysGraphics(e.target.value);
        }
        if (e.target.name === "api_store_id_harrier") {
            setApiStoreIdHarrier(e.target.value);
        }
        if (e.target.name === "api_store_id_print_pigeons") {
            setApiStoreIdPrintPigeons(e.target.value);
        }
        if (e.target.name === "api_store_id_colorway") {
            setApiStoreIdColorway(e.target.value);
        }
        if (e.target.name === "api_store_id_printed_simply") {
            setApiStoreIdPrintedSimply(e.target.value);
        }
        if (e.target.name === "api_store_id_imagine_your_photos") {
            setApiStoreIdImagineYourPhotos(e.target.value);
        }
        if (e.target.name === "api_store_id_pic_the_gift") {
            setApiStoreIdPicTheGift(e.target.value);
        }
        if (e.target.name === "api_store_id_woyc") {
            setApiStoreIdWoyc(e.target.value);
        }
        if (e.target.name === "api_store_id_smart_printee") {
            setApiStoreIdSmartPrintee(e.target.value);
        }
        if (e.target.name === "api_store_id_shirt_monkey") {
            setApiStoreIdShirtMonkey(e.target.value);
        }
        if (e.target.name === "api_store_id_t_shirt_and_sons") {
            setApiStoreIdTShirtAndSons(e.target.value);
        }
        if (e.target.name === "api_store_id_print_clever") {
            setApiStoreIdPrintClever(e.target.value);
        }
        if (e.target.name === "api_store_id_printify_choice") {
            setApiStoreIdPrintifyChoice(e.target.value);
        }
        if (e.target.name === "api_store_id_printful_com") {
            setApiStoreIdPrintfulCom(e.target.value);
        }
        if (e.target.name === "api_store_id_opt_ondemand") {
            setApiStoreIdOptOndemand(e.target.value);
        }
        if (e.target.name === "api_store_id_atelier_katanga") {
            setApiStoreIdAtelierKatanga(e.target.value);
        }
        if (e.target.name === "webhook_secret_key") {
            setWebhookSecretKey(e.target.value);
        }
        if (e.target.name === "base_url") {
            setBaseUrl(e.target.value);
        }
        if (e.target.name === "client_id") {
            setClientId(e.target.value);
        }
        if (e.target.name === "client_secret") {
            setClientSecret(e.target.value);
        }
        if (e.target.name === "app_key") {
            setAppKey(e.target.value);
        }
        if (e.target.name === "app_secret") {
            setAppSecret(e.target.value);
        }
    }

    const onChangeDataViettelpost = (e) => {
        const { name, value } = e.target;
        const [parent, field] = name.split(".");

        setData((prev) => ({
            ...prev,
            [parent]: {
                ...prev[parent],
                [field]: value
            }
        }));
    }

    const onOpenModal = () => {
        openModal();
    };

    const onKeyPress = (e) => {
        if ((/^[0-9.]+$/).test(e)) {
            e.preventDefault();
        }
    }

    return (
        <Fragment>
            <Modal centered={true} size={(printer === "viettelpost_1" || printer === "viettelpost_2") ? "xl" : "lg"} toggle={() => { onOpenModal() }} isOpen={isOpenModalAddPrinter}>
                <Loading isLoading={isLoading} />
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Add Printer")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i className="ki-outline ki-cross fs-1" onClick={() => { onOpenModal() }} ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                            <span className="required">{t("Printer")}</span>
                        </label>
                        <select className="form-select" data-control="select2" data-hide-search="true" data-placeholder="Select a printer" value={printer} name="printer" onChange={(e) => { onChange(e) }} disabled >
                            <option value="">{t("-- Select a printer --")}</option>
                            <option value="flashship">Flashship</option>
                            <option value="mangoteeprints">Mangoteeprints</option>
                            <option value="gearment">Gearment</option>
                            <option value="hmfulfill">HM Fulfill</option>
                            <option value="lenful">Lenful</option>
                            <option value="onospod">OnosPOD</option>
                            <option value="a2kecom">A2K Ecom</option>
                            <option value="printeeshub">Printeeshub</option>
                            <option value="monkeykingprint">Monkeykingprint</option>
                            <option value="kvfulfill">KV Fulfill</option>
                            <option value="visiovsolutions">VisiovSolutions</option>
                            <option value="saigongroups">Saigongroups.us</option>
                            <option value="burgerprints">Burgerprints</option>
                            <option value="printiz">Printiz</option>
                            <option value="printify">Printify</option>
                            <option value="oneprint">Oneprint</option>
                            <option value="opcreative">OP Creative</option>
                            <option value="menprint">Menprint</option>
                            <option value="teroprints">Teroprints</option>
                            <option value="fprint">Fprint</option>
                            <option value="printsel">Printsel</option>
                            <option value="tebprint">Tebprint</option>
                            <option value="mmotaxhub">MMOTaxHub</option>
                            <option value="merchize">Merchize</option>
                            <option value="saigongroupsnet">Saigongroups.net</option>
                            <option value="pressify">Pressify</option>
                            <option value="thgfulfill">THG Fulfill</option>
                            <option value="smartfactore">Smartfactore</option>
                            <option value="viettelpost_1">Viettelpost 1</option>
                            <option value="viettelpost_2">Viettelpost 2</option>
                            <option value="lizyprintfull">Lizyprintfull</option>
                            <option value="sellerwix">Sellerwix</option>
                            <option value="anprints">Anprints</option>
                            <option value="hogotopod">Hogotopod</option>
                            <option value="dreamship">Dreamship</option>
                            <option value="printdoors">Printdoors</option>
                            <option value="merchfox">Merchfox</option>
                            <option value="printory">Printory</option>
                            <option value="treesprint">Treesprint</option>
                            <option value="bullstart">Bullstart</option>
                        </select>
                    </div>
                    {
                        printer === "flashship" || printer === "hmfulfill" || printer === "lenful" || printer === "monkeykingprint" || printer === "kvfulfill" || printer === "saigongroups" || printer === "printsel" || printer === "printiz" || printer === "mmotaxhub" || printer === "saigongroupsnet" || printer === "bullstart" ?
                            <Fragment>
                                <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                    <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                        <span className="required">{t("Username")}</span>
                                    </label>
                                    <input type="text" className="form-control" value={username} placeholder={t("Username")} name="username" onChange={(e) => { onChange(e) }} />
                                </div>
                            </Fragment>
                        : ""
                    }
                    {
                        printer === "flashship" || printer === "hmfulfill" || printer === "lenful" || printer === "monkeykingprint" || printer === "kvfulfill" || printer === "saigongroups" || printer === "printsel" || printer === "printiz" || printer === "mmotaxhub" || printer === "bullstart" ?
                            <Fragment>
                                <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                    <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                        <span className="required">{t("Password")}</span>
                                    </label>
                                    <input type="password" className="form-control" value={password} placeholder={t("Password")} name="password" onChange={(e) => { onChange(e) }} />
                                </div>
                            </Fragment>
                        : ""
                    }
                    {
                        printer === "mangoteeprints" || printer === "onospod" || printer === "a2kecom" || printer === "visiovsolutions" || printer === "printify" || printer === "menprint" || printer === "fprint" ?
                            <Fragment>
                                <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                    <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                        <span className="required">{t("Access Token")}</span>
                                    </label>
                                    <input type="text" className="form-control" value={access_token} placeholder={t("Access Token")} name="access_token" onChange={(e) => { onChange(e) }} />
                                </div>
                                {
                                    printer === "mangoteeprints" ?
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Auto Place")}</span>
                                            </label>
                                            <div className="form-check form-check-solid form-switch form-check-custom fv-row">
                                                <input type="checkbox" className="form-check-input w-45px h-30px" value={!auto_place} id="auto_place" name="auto_place" checked={auto_place} onChange={(e) => { onChange(e) }} />
                                                <label className="form-check-label" htmlFor="auto_place"></label>
                                            </div>
                                        </div>
                                    : ""
                                }
                                {
                                    printer === "printify" ?
                                        <Fragment>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - SPOKE Custom Products")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_spoke_custom_products} placeholder={t("Store ID - SPOKE Custom Products")} name="api_store_id_spoke_custom_products" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - SwiftPOD")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_swiftpod} placeholder={t("Store ID - SwiftPOD")} name="api_store_id_swiftpod" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Monster Digital")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_monster_digital} placeholder={t("Store ID - Monster Digital")} name="api_store_id_monster_digital" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Printed Mint")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_printed_mint} placeholder={t("Store ID - Printed Mint")} name="api_store_id_printed_mint" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Lumient")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_lumient} placeholder={t("Store ID - Lumient")} name="api_store_id_lumient" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - SwagRabbit")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_swagrabbit} placeholder={t("Store ID - SwagRabbit")} name="api_store_id_swagrabbit" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Candle Builders")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_candle_builders} placeholder={t("Store ID - Candle Builders")} name="api_store_id_candle_builders" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Prima Printing")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_prima_printing} placeholder={t("Store ID - Prima Printing")} name="api_store_id_prima_printing" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - District Photo")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_district_photo} placeholder={t("Store ID - District Photo")} name="api_store_id_district_photo" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Today's Graphics")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_todays_graphics} placeholder={t("Store ID - Today's Graphics")} name="api_store_id_todays_graphics" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Harrier")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_harrier} placeholder={t("Store ID - Harrier")} name="api_store_id_harrier" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Print Pigeons")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_print_pigeons} placeholder={t("Store ID - Print Pigeons")} name="api_store_id_print_pigeons" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Colorway")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_colorway} placeholder={t("Store ID - Colorway")} name="api_store_id_colorway" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Printed Simply")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_printed_simply} placeholder={t("Store ID - Printed Simply")} name="api_store_id_printed_simply" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Imagine Your Photos")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_imagine_your_photos} placeholder={t("Store ID - Imagine Your Photos")} name="api_store_id_imagine_your_photos" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Pic the Gift")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_pic_the_gift} placeholder={t("Store ID - Pic the Gift")} name="api_store_id_pic_the_gift" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - WOYC")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_woyc} placeholder={t("Store ID - WOYC")} name="api_store_id_woyc" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Smart Printee")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_smart_printee} placeholder={t("Store ID - Smart Printee")} name="api_store_id_smart_printee" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Shirt Monkey")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_shirt_monkey} placeholder={t("Store ID - Shirt Monkey")} name="api_store_id_shirt_monkey" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - T Shirt and Sons")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_t_shirt_and_sons} placeholder={t("Store ID - T Shirt and Sons")} name="api_store_id_t_shirt_and_sons" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Print Clever")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_print_clever} placeholder={t("Store ID - Print Clever")} name="api_store_id_print_clever" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Printify Choice")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_printify_choice} placeholder={t("Store ID - Printify Choice")} name="api_store_id_printify_choice" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Printful.com")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_printful_com} placeholder={t("Store ID - Printful.com")} name="api_store_id_printful_com" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - OPT OnDemand")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_opt_ondemand} placeholder={t("Store ID - OPT OnDemand")} name="api_store_id_opt_ondemand" onChange={(e) => { onChange(e) }} />
                                            </div>
                                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                    <span className="required">{t("Store ID - Atelier Katanga")}</span>
                                                </label>
                                                <input type="text" className="form-control" value={api_store_id_atelier_katanga} placeholder={t("Store ID - Atelier Katanga")} name="api_store_id_atelier_katanga" onChange={(e) => { onChange(e) }} />
                                            </div>
                                        </Fragment>
                                    : ""
                                }
                            </Fragment>
                        : ""
                    }
                    {
                        printer === "gearment" || printer === "printeeshub" || printer === "burgerprints" || printer === "oneprint" || printer === "opcreative" || printer === "teroprints" || printer === "tebprint" || printer === "merchize" || printer === "saigongroupsnet" || printer === "pressify" || printer === "thgfulfill" || printer === "smartfactore" || printer === "lizyprintfull" || printer === "sellerwix" || printer === "anprints" || printer === "hogotopod" || printer === "dreamship" || printer === "merchfox" || printer === "printory" || printer === "treesprint" ?
                            <Fragment>
                                <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                    <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                        <span className="required">{t("API key")}</span>
                                    </label>
                                    <input type="text" className="form-control" value={api_key} placeholder={t("API key")} name="api_key" onChange={(e) => { onChange(e) }} />
                                </div>
                                {
                                    printer === "gearment" ?
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("API signature")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={api_signature} placeholder={t("API signature")} name="api_signature" onChange={(e) => { onChange(e) }} />
                                        </div>
                                    : ""
                                }
                                {
                                    printer === "oneprint" || printer === "thgfulfill" || printer === "lizyprintfull" || printer === "merchfox" ?
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("API secret")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={api_secret} placeholder={t("API secret")} name="api_secret" onChange={(e) => { onChange(e) }} />
                                        </div>
                                    : ""
                                }
                                {
                                    printer === "merchize" ?
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Base Url")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={base_url} placeholder={t("Base Url")} name="base_url" onChange={(e) => { onChange(e) }} />
                                        </div>
                                    : ""
                                }
                                {
                                    printer === "merchize" ?
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Webhook Secret Key")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={webhook_secret_key} placeholder={t("Webhook Secret Key")} name="webhook_secret_key" onChange={(e) => { onChange(e) }} />
                                            <div className="fw-semibold text-gray-500 mt-1">Link Add Webhook (Event: Order payment fulfillment cost paid): <strong>https://cotik.app/api/webhook/merchize</strong></div>
                                        </div>
                                    : ""
                                }
                                {
                                    printer === "tebprint" || printer === "merchize" || printer === "sellerwix" ?
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Store ID")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={api_store_id} placeholder={t("Store ID")} name="api_store_id" onChange={(e) => { onChange(e) }} />
                                        </div>
                                    : ""
                                }
                            </Fragment>
                        : ""
                    }
                    {
                        printer === "viettelpost_1" || printer === "viettelpost_2" ?
                            <Fragment>
                                <div className="row">
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Client ID")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={client_id} placeholder={t("Client ID")} name="client_id" onChange={(e) => { onChange(e) }} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Client Secret")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={client_secret} placeholder={t("Client Secret")} name="client_secret" onChange={(e) => { onChange(e) }} />
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                                <div className="mb-5 text-center">
                                    <h2 className="fw-bold">{t("-- Shop From --")}</h2>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("First Name")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={data?.ship_from?.first_name || ""} placeholder={t("First Name")} name="ship_from.first_name" onChange={(e) => { onChangeDataViettelpost(e) }} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Last Name")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={data?.ship_from?.last_name || ""} placeholder={t("Last Name")} name="ship_from.last_name" onChange={(e) => { onChangeDataViettelpost(e) }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Email")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={data?.ship_from?.email || ""} placeholder={t("Email")} name="ship_from.email" onChange={(e) => { onChangeDataViettelpost(e) }} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Phone Number")}</span>
                                            </label>
                                            <input type="number" className="form-control" value={data?.ship_from?.phone_number || ""} placeholder={t("Phone Number")} name="ship_from.phone_number" onChange={(e) => { onChangeDataViettelpost(e) }} onKeyPress={(e) => {onKeyPress(e)}} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="">{t("Company")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={data?.ship_from?.company || ""} placeholder={t("Company")} name="ship_from.company" onChange={(e) => { onChangeDataViettelpost(e) }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Address1")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={data?.ship_from?.address1 || ""} placeholder={t("Address1")} name="ship_from.address1" onChange={(e) => { onChangeDataViettelpost(e) }} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="">{t("Address2")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={data?.ship_from?.address2 || ""} placeholder={t("Address2")} name="ship_from.address2" onChange={(e) => { onChangeDataViettelpost(e) }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Country")}</span>
                                            </label>
                                            <select className="form-select" data-control="select2" data-hide-search="true" data-placeholder="Select a weight unit" value={data?.ship_from?.country || ""} name="ship_from.country" onChange={(e) => { onChangeDataViettelpost(e) }} >
                                                <option value="">{t("-- Select a country --")}</option>
                                                <option value="VN">{t("VN")}</option>
                                                <option value="US">{t("US")}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("State")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={data?.ship_from?.state || ""} placeholder={t("State")} name="ship_from.state" onChange={(e) => { onChangeDataViettelpost(e) }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("City")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={data?.ship_from?.city || ""} placeholder={t("City")} name="ship_from.city" onChange={(e) => { onChangeDataViettelpost(e) }} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Ward")}</span>
                                            </label>
                                            <input type="text" className="form-control" value={data?.ship_from?.ward || ""} placeholder={t("Ward")} name="ship_from.ward" onChange={(e) => { onChangeDataViettelpost(e) }} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Zip Code")}</span>
                                            </label>
                                            <input type="number" className="form-control" value={data?.ship_from?.zip_code || ""} placeholder={t("Zip Code")} name="ship_from.zip_code" onChange={(e) => { onChangeDataViettelpost(e) }} onKeyPress={(e) => {onKeyPress(e)}} />
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                                <div className="mb-5 text-center">
                                    <h2 className="fw-bold">{t("-- Parcel --")}</h2>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Weight")}</span>
                                            </label>
                                            <input type="number" className="form-control" value={data?.parcel?.weight || ""} placeholder={t("Weight")} name="parcel.weight" onChange={(e) => { onChangeDataViettelpost(e) }} onKeyPress={(e) => {onKeyPress(e)}} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Weight Unit")}</span>
                                            </label>
                                            <select className="form-select" data-control="select2" data-hide-search="true" data-placeholder="Select a weight unit" value={data?.parcel?.weight_unit || ""} name="parcel.weight_unit" onChange={(e) => { onChangeDataViettelpost(e) }} >
                                                <option value="">{t("-- Select a weight unit --")}</option>
                                                <option value="0">{t("Oz")}</option>
                                                <option value="1">{t("Lbs")}</option>
                                                <option value="2">{t("Gram")}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Length")}</span>
                                            </label>
                                            <input type="number" className="form-control" value={data?.parcel?.length || ""} placeholder={t("Length")} name="parcel.length" onChange={(e) => { onChangeDataViettelpost(e) }} onKeyPress={(e) => {onKeyPress(e)}} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Width")}</span>
                                            </label>
                                            <input type="number" className="form-control" value={data?.parcel?.width || ""} placeholder={t("Width")} name="parcel.width" onChange={(e) => { onChangeDataViettelpost(e) }} onKeyPress={(e) => {onKeyPress(e)}} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Height")}</span>
                                            </label>
                                            <input type="number" className="form-control" value={data?.parcel?.height || ""} placeholder={t("Height")} name="parcel.height" onChange={(e) => { onChangeDataViettelpost(e) }} onKeyPress={(e) => {onKeyPress(e)}} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                                <span className="required">{t("Length Unit")}</span>
                                            </label>
                                            <select className="form-select" data-control="select2" data-hide-search="true" data-placeholder="Select a length unit" value={data?.parcel?.length_unit || ""} name="parcel.length_unit" onChange={(e) => { onChangeDataViettelpost(e) }} >
                                                <option value="">{t("-- Select a length unit --")}</option>
                                                <option value="0">{t("In")}</option>
                                                <option value="1">{t("cm")}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        : ""
                    }
                    {
                        printer === "printdoors" ?
                            <Fragment>
                                <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                    <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                        <span className="required">{t("App key")}</span>
                                    </label>
                                    <input type="text" className="form-control" value={app_key} placeholder={t("App key")} name="app_key" onChange={(e) => { onChange(e) }} />
                                </div>
                                <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                    <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                        <span className="required">{t("App secret")}</span>
                                    </label>
                                    <input type="text" className="form-control" value={app_secret} placeholder={t("App secret")} name="app_secret" onChange={(e) => { onChange(e) }} />
                                </div>
                            </Fragment>
                        : ""
                    }
                </ModalBody>
                <ModalFooter>
                    <button type="reset" id="kt_modal_users_search_reset" data-bs-dismiss="modal" className="btn btn-active-light me-3" onClick={() => { onOpenModal() }} >{t("Cancel")}</button>
                    <button type="submit" id="kt_modal_users_search_submit" className="btn btn-primary" onClick={() => { onClickSaveAddPrinter() }}  >{t("Save")}</button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

Modaladdprinter.propTypes = {
    saveAddPrinter: PropTypes.func.isRequired
};
const mapStateToProps = state => ({
    printer: state.printer
});
const mapDispatchToProps = {
    saveAddPrinter
}

export default connect(mapStateToProps, mapDispatchToProps)(Modaladdprinter);